"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/table/style/css");
var table_1 = __importDefault(require("antd/lib/table"));
require("antd/lib/modal/style/css");
var modal_1 = __importDefault(require("antd/lib/modal"));
require("antd/lib/space/style/css");
var space_1 = __importDefault(require("antd/lib/space"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var icons_1 = require("@ant-design/icons");
var MapPreview_1 = __importDefault(require("./MapPreview"));
var pages_1 = require("../../hooks/pages");
var actions_1 = require("../../modules/layers/actions");
var hooks_1 = require("../../modules/stations/hooks");
var utils_1 = require("../../utils");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var LayerListView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _useAuth = (0, auth0_react_1.useAuth0)(), getAccessTokenSilently = _useAuth.getAccessTokenSilently;
    var layersInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.layers.initialFetchDone;
    });
    var layersFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.layers.isFetching;
    });
    var layers = (0, react_redux_1.useSelector)(function (state) {
        return state.layers.items;
    });
    var _useStations = (0, hooks_1.useStations)(), stations = _useStations.items;
    var _useState = (0, react_1.useState)(false), _useState2 = _slicedToArray(_useState, 2), previewShown = _useState2[0], setPreviewShown = _useState2[1];
    var _useState3 = (0, react_1.useState)(null), _useState4 = _slicedToArray(_useState3, 2), delLayer = _useState4[0], setDelLayer = _useState4[1];
    var columns = (0, react_1.useMemo)(function () {
        return [{
                title: "Name",
                dataIndex: "name"
            }, {
                title: "Enabled",
                dataIndex: "enabled",
                shouldCellUpdate: function shouldCellUpdate(r, pr) {
                    return (r === null || r === void 0 ? void 0 : r.enabled) !== (pr === null || pr === void 0 ? void 0 : pr.enabled);
                },
                render: function render(enabled) {
                    return enabled ? "Yes" : "No";
                }
            }, {
                title: "Rank",
                dataIndex: "rank"
            }, {
                title: "Actions",
                key: "actions",
                shouldCellUpdate: function shouldCellUpdate(r, pr) {
                    return (r === null || r === void 0 ? void 0 : r.id) !== (pr === null || pr === void 0 ? void 0 : pr.id);
                },
                render: function render(layer) {
                    return (0, jsx_runtime_1.jsxs)(space_1.default, {
                        size: "small",
                        children: [(0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/layers/detail/".concat(layer.id));
                                },
                                children: "View"
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/layers/edit/".concat(layer.id));
                                },
                                children: "Edit"
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}),
                                danger: true,
                                onClick: function onClick() {
                                    return setDelLayer(layer);
                                },
                                children: "Delete"
                            })]
                    });
                }
            }];
    }, [navigate]);
    var showPreview = (0, react_1.useCallback)(function () {
        return setPreviewShown(true);
    }, []);
    var hidePreview = (0, react_1.useCallback)(function () {
        return setPreviewShown(false);
    }, []);
    var onAdd = (0, react_1.useCallback)(function () {
        return navigate("/layers/add");
    }, [navigate]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                onClick: showPreview,
                children: "Preview Map"
            }, "preview"), (0, jsx_runtime_1.jsx)(button_1.default, {
                type: "primary",
                icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}),
                onClick: onAdd,
                children: "Add New"
            }, "add")];
    }, [showPreview, onAdd]);
    var closeDelModal = (0, react_1.useCallback)(function () {
        return setDelLayer(null);
    }, []);
    var onDisable = (0, react_1.useCallback)(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
        var token, _t;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.p = _context.n) {
                    case 0:
                        if (delLayer) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2);
                    case 1:
                        _context.p = 1;
                        _context.n = 2;
                        return getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE);
                    case 2:
                        token = _context.v;
                        _context.n = 3;
                        return dispatch((0, actions_1.updateLayer)(delLayer.id, {
                            enabled: false
                        }, token));
                    case 3:
                        _context.n = 5;
                        break;
                    case 4:
                        _context.p = 4;
                        _t = _context.v;
                        console.error(_t);
                    case 5:
                        closeDelModal();
                    case 6:
                        return _context.a(2);
                }
        }, _callee, null, [[1, 4]]);
    })), [dispatch, getAccessTokenSilently, delLayer]);
    var onDelete = (0, react_1.useCallback)(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var token, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        if (delLayer) {
                            _context2.n = 1;
                            break;
                        }
                        return _context2.a(2);
                    case 1:
                        _context2.p = 1;
                        _context2.n = 2;
                        return getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE);
                    case 2:
                        token = _context2.v;
                        _context2.n = 3;
                        return dispatch((0, actions_1.deleteLayer)(delLayer.id, token));
                    case 3:
                        _context2.n = 5;
                        break;
                    case 4:
                        _context2.p = 4;
                        _t2 = _context2.v;
                        console.error(_t2);
                    case 5:
                        closeDelModal();
                    case 6:
                        return _context2.a(2);
                }
        }, _callee2, null, [[1, 4]]);
    })), [dispatch, getAccessTokenSilently, delLayer]);
    var pagination = (0, pages_1.useUrlPagination)();
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        title: "Layers",
        subTitle: "View and edit map layers",
        extra: extra,
        children: [(0, jsx_runtime_1.jsx)(modal_1.default, {
                title: "Map Preview",
                open: previewShown,
                footer: null,
                onCancel: hidePreview,
                width: 800,
                children: (0, jsx_runtime_1.jsx)(MapPreview_1.default, {
                    layers: layers,
                    stations: stations
                })
            }), (0, jsx_runtime_1.jsxs)(modal_1.default, {
                title: "Delete layer: ".concat(delLayer === null || delLayer === void 0 ? void 0 : delLayer.name),
                open: !!delLayer,
                onCancel: closeDelModal,
                footer: (0, jsx_runtime_1.jsxs)(space_1.default, {
                    children: [(0, jsx_runtime_1.jsx)(button_1.default, {
                            type: "primary",
                            danger: true,
                            icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}),
                            onClick: onDelete,
                            children: "Delete"
                        }), delLayer !== null && delLayer !== void 0 && delLayer.enabled ? (0, jsx_runtime_1.jsx)(button_1.default, {
                            type: "primary",
                            icon: (0, jsx_runtime_1.jsx)(icons_1.CloseSquareOutlined, {}),
                            onClick: onDisable,
                            children: "Disable"
                        }) : null, (0, jsx_runtime_1.jsx)(button_1.default, {
                            onClick: closeDelModal,
                            children: "Cancel"
                        })]
                }),
                children: ["Are you sure you wish to delete the layer \u201C", delLayer === null || delLayer === void 0 ? void 0 : delLayer.name, "\u201D?\xA0", delLayer !== null && delLayer !== void 0 && delLayer.enabled ? (0, jsx_runtime_1.jsxs)("span", {
                        children: ["If you wish, you can ", (0, jsx_runtime_1.jsx)("a", {
                                href: "#",
                                onClick: onDisable,
                                children: "disable"
                            }), " this layer instead."]
                    }) : ""]
            }), (0, jsx_runtime_1.jsx)(table_1.default, {
                bordered: true,
                size: "small",
                loading: !layersInitialFetch && layersFetching,
                columns: columns,
                dataSource: layers,
                rowKey: "id",
                pagination: pagination
            })]
    });
});
exports.default = LayerListView;
